import * as React from 'react';

import { ControlsLayout } from '../../components/ControlsLayout';
import { DifferencesSwitchContainer } from '../DifferenciesSwitch';

export const ControlsContainer = (): React.JSX.Element => {
  return (
    <ControlsLayout>
      <DifferencesSwitchContainer />
    </ControlsLayout>
  );
};
